import './imageDetails.css';
import galleryItems from '../../data/gallery.json';
import { useParams, Link } from "react-router-dom";
import { FiArrowLeft } from 'react-icons/fi';

interface GalleryItem {
    name: string;
    path: string;
    image: string;
}

const ImageDetails = () => {
    const { id } = useParams();
    const item = galleryItems.find((item) => item.id === Number(id)) as GalleryItem;
    return (
        <section id="gallery" className='image-details-container'>
            <Link to="/" className="back-arrow" aria-label="Back to Home">
                <FiArrowLeft aria-hidden="true" />
            </Link>

            <img src={item.image} alt={item.name || item.image} className="photo-details" />
        </section>
    );
};

export default ImageDetails;
